import { DATA_LAYER_ENDPOINT } from "@config/endpoints";
import { ThunkActionDispatch } from "@typings/reduxThunkActions";

import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";

import { IStore } from "@app/redux/reducers";
import { asyncActionCreator } from "@app/services/AsyncActionCreator";

const action = new ReduxActionNameCreator("data layer");

export const FETCH_DATA_LAYER = action.make("fetch");

export const fetchDataLayer = () => async (
  dispatch: ThunkActionDispatch,
  store: () => IStore,
) => {
  const action = await asyncActionCreator({
    url: DATA_LAYER_ENDPOINT,
    action: FETCH_DATA_LAYER,
  });

  return dispatch(action);
};
